import { motion } from 'framer-motion';

function SkillGapCard({ gap }) {
  const severityConfig = {
    critical: {
      icon: '🔴',
      color: 'red',
      label: 'Critical Issue',
    },
    important: {
      icon: '⚠️',
      color: 'amber',
      label: 'Needs Improvement',
    },
    'nice-to-have': {
      icon: 'ℹ️',
      color: 'blue',
      label: 'Opportunity',
    },
  };

  const config = severityConfig[gap.severity];

  const colorClasses = {
    red: {
      bg: 'bg-red-500/10',
      border: 'border-red-500/30',
      text: 'text-red-400',
      progress: 'bg-red-500',
    },
    amber: {
      bg: 'bg-amber-500/10',
      border: 'border-amber-500/30',
      text: 'text-amber-400',
      progress: 'bg-amber-500',
    },
    blue: {
      bg: 'bg-blue-500/10',
      border: 'border-blue-500/30',
      text: 'text-blue-400',
      progress: 'bg-blue-500',
    },
  };

  const colors = colorClasses[config.color] || colorClasses.blue;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`${colors.bg} ${colors.border} border rounded-lg p-4`}
    >
      {/* Header */}
      <div className="flex items-start gap-3 mb-2">
        <span className="text-2xl flex-shrink-0">{config.icon}</span>
        <div className="flex-1">
          <div className="flex items-center justify-between mb-1">
            <h4 className="text-sm font-semibold text-gray-50">{gap.title}</h4>
            <span className={`text-xs font-medium ${colors.text}`}>{gap.score}/100</span>
          </div>
          <p className="text-sm text-gray-400">{gap.description}</p>
        </div>
      </div>

      {/* Example (if provided) */}
      {gap.example && (
        <div className="mt-3 pl-11">
          <div className="bg-slate-900 border border-white/10 rounded p-3">
            <p className="text-xs text-gray-400">Example:</p>
            <p className="text-sm text-gray-300 mt-1">{gap.example}</p>
          </div>
        </div>
      )}

      {/* Progress bar */}
      <div className="mt-3 pl-11">
        <div className="h-2 bg-slate-900 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${gap.score}%` }}
            transition={{ duration: 1, delay: 0.5 }}
            className={`h-full ${colors.progress} transition-all duration-1000`}
          />
        </div>
      </div>
    </motion.div>
  );
}

export default function SkillGapsSection({ gaps }) {
  if (gaps.length === 0) return null;

  return (
    <div className="mt-8">
      <h3 className="text-xl font-semibold text-gray-50 mb-4">Areas for Improvement</h3>

      <div className="space-y-3">
        {gaps.map((gap, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.5 + idx * 0.1 }}
          >
            <SkillGapCard gap={gap} />
          </motion.div>
        ))}
      </div>
    </div>
  );
}
